import { render } from "./TeacherBindStudent.vue?vue&type=template&id=33efe21e&scoped=true"
import script from "./TeacherBindStudent.vue?vue&type=script&lang=js"
export * from "./TeacherBindStudent.vue?vue&type=script&lang=js"

import "./TeacherBindStudent.vue?vue&type=style&index=0&id=33efe21e&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33efe21e"]])

export default __exports__